import { Form } from 'antd';
import { useMemo } from 'react';

import { useKimLhcAutoCalculate, BaseCalculationPayload } from '@/components/views/Report/KimLhc/hooks/useKimLhcAutoCalculate';
import { FieldNamesEnum } from '@/components/views/Report/KimLhc/types';

interface CalculatedScores {
	workOrganizationScore: number;
	manScore: number;
	womanScore: number;
}

interface WorkOrganizationFormData {
	work_organization?: string;
}

interface CalculateScoresResponse {
	work_organization_score: number;
	man_score: number;
	woman_score: number;
}

const INITIAL_SCORES: CalculatedScores = {
	workOrganizationScore: 0,
	manScore: 0,
	womanScore: 0
};

function buildPayload(formData: WorkOrganizationFormData, basePayload: BaseCalculationPayload) {
	return { ...basePayload, ...formData };
}

function transformScores(scores: CalculateScoresResponse): CalculatedScores {
	return {
		workOrganizationScore: scores.work_organization_score,
		manScore: scores.man_score,
		womanScore: scores.woman_score
	};
}

export function useAutoCalculate() {
	const form = Form.useFormInstance();
	const WORK_ORGANIZATION_GROUP = FieldNamesEnum.WORK_ORGANIZATION;

	const temporalDistribution = Form.useWatch([WORK_ORGANIZATION_GROUP, 'work_organization'], form);

	const watchedValues = useMemo(
		() => ({
			work_organization: temporalDistribution
		}),
		[temporalDistribution]
	);

	return useKimLhcAutoCalculate<WorkOrganizationFormData, CalculatedScores, CalculateScoresResponse>({
		watchedValues,
		initialScores: INITIAL_SCORES,
		buildPayload,
		transformScores
	});
}
